import { render, staticRenderFns } from "./leftColHalf.vue?vue&type=template&id=25d534a5"
import script from "./leftColHalf.vue?vue&type=script&lang=js"
export * from "./leftColHalf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports